import { render } from "./Loader.vue?vue&type=template&id=50372a0b&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=50372a0b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50372a0b"

export default script